<script setup lang="ts">
import ChevronLeftIcon from '@/assets/icons/Planning/ChevronLeftIcon.vue';
import ChevronRightIcon from '@/assets/icons/Planning/ChevronRightIcon.vue';
import { formatDate } from '@/utils/date';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  weekNumber: number;
  weekRange: { start: Date; end: Date };
}>();

defineEmits<{
  (e: 'previous-week'): void;
  (e: 'next-week'): void;
}>();

const { t } = useI18n();

const weekLabel = computed(() => t('planning.weekInfo', { weekNumber: props.weekNumber }));

const formattedStart = computed(() => formatDate(props.weekRange.start));
const formattedEnd = computed(() => formatDate(props.weekRange.end));
</script>

<template>
  <div class="flex items-center justify-center">
    <!-- Previous week button -->
    <button class="rounded-l-lg" @click="$emit('previous-week')">
      <ChevronLeftIcon class="h-12 w-12 text-primary-500" />
    </button>
    <!-- Display the week number and date range -->
    <div class="px-4 text-center">
      <div>
        <p>{{ weekLabel }}</p>
      </div>
      <div class="text-sm">
        <p>{{ formattedStart }} - {{ formattedEnd }}</p>
      </div>
    </div>
    <button class="rounded-r-lg" @click="$emit('next-week')">
      <ChevronRightIcon class="h-12 w-12 text-primary-500" />
    </button>
  </div>
</template>
